import React from 'react';
import { createToast, Toast, ToastType } from 'components/core';

type props = {
  toastMessage: string;
  type?: ToastType;
  duration?: number;
};

const createStudyMergeToast = ({
  toastMessage,
  type = 'neutral',
  duration = 10000, // default duration 10 seconds
}: props) => {
  createToast(<Toast type={type}>{toastMessage}</Toast>, {
    duration: duration,
  });
};

export default createStudyMergeToast;
